import React, { useContext } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import { RouteContext } from "../outboundAmzl/context/RouteContextProvider";
import { OutboundFilterContext } from "../outboundAmzl/context/OutboundFilterContext";
import { OutboundConfigContext } from "../outboundAmzl/context/OutboundConfigContext";
import {
  getTargetTabByMetric,
  filterRouteCut,
} from "../outboundAmzl/util/Util";
import ActionableMetricViewV2 from "../outboundAmzl/ActionableMetricViewV2";
import BoxMetricViewV2 from "../outboundAmzl/BoxMetricViewV2";
import StaticMetricView from "../outboundAmzl/StaticMetricView";
import {
  DEPARTED,
  ROUTES_AT_RISK,
  ROUTES_TO_BE_CUT,
  PENDING_DEPART,
  PENDING_STAGE,
  PENDING_PICK,
  getRouteCountByStatus,
  getRouteAtRiskCountARv2,
  getRouteFilterByMetric,
} from "../outboundAmzl/RouteStatusManager";
import RefreshTimer from "../RefreshTimer";
import { CapabilityContext } from "../overview/context/CapabilityContext";

const OutboundOverviewARV2View = (props) => {
  const { capability } = useContext(CapabilityContext);
  const { viewModel } = useContext(RouteContext);
  const { viewModelF } = useContext(OutboundFilterContext);
  const { outboundConfigModel } = useContext(OutboundConfigContext);
  let routeList = viewModel.routeList;

  const filterDeparture = (route) => {
    if (viewModelF.departure.length === 0) {
      return true;
    }
    let result = false;
    viewModelF.departure.forEach((departure) => {
      if (route.routeSLA.includes(departure)) {
        result = true;
      }
    });
    return result;
  };

  routeList = routeList.filter((route) => filterDeparture(route));

  const getMetricUri = (metric, capability) => {
    let filterObj = getRouteFilterByMetric(
      metric,
      viewModelF,
      outboundConfigModel.stationConfig,
      capability,
    );
    filterObj = {
      xptNodes: viewModelF.xptNodes,
      cluster: viewModelF.cluster,
      driverType: viewModelF.driverType,
      departure: viewModelF.departure,
      ...filterObj,
    };
    return JSON.stringify(filterObj).replace("/", "%2f");
  };

  const renderTotalsView = () => {
    return (
      <BoxMetricViewV2
        data={{
          headerId: "outboundARV2.totals",
          defaultHeader: "Totals",
          value: routeList.length,
          footerId: "outboundARV2.routes",
          defaultFooter: "Routes",
        }}
      />
    );
  };

  const renderAtRiskMetric = () => {
    return (
      <ActionableMetricViewV2
        data={{
          title: "outboundARV2.routeAtRisk",
          message: "Delayed pick",
          value: getRouteAtRiskCountARv2(routeList),
          targetTab: getTargetTabByMetric(ROUTES_AT_RISK),
          uri: getMetricUri(ROUTES_AT_RISK, capability.data),
        }}
      />
    );
  };

  const renderToBeCutMetric = () => {
    return (
      <ActionableMetricViewV2
        data={{
          title: "outboundARV2.toBeCut",
          message: "To be cut",
          value: filterRouteCut(
            routeList,
            viewModelF.rcTimeLimit,
            viewModelF.rcPackageCount,
          ),
          targetTab: getTargetTabByMetric(ROUTES_TO_BE_CUT),
          uri: getMetricUri(ROUTES_TO_BE_CUT, capability.data),
        }}
      />
    );
  };

  const renderNotAssignedMetric = () => {
    return (
      <StaticMetricView
        data={{
          title: "outboundARV2.notAssigned",
          message: "Not assigned",
          value: viewModel.routesNotAssignedCount,
        }}
      />
    );
  };

  const renderInProgressMetric = () => {
    return (
      <ActionableMetricViewV2
        data={{
          title: "outboundARV2.inProgress",
          message: "In progress",
          value: getRouteCountByStatus(PENDING_PICK, routeList),
          targetTab: getTargetTabByMetric(PENDING_PICK),
          uri: getMetricUri(PENDING_PICK),
        }}
      />
    );
  };

  const renderPickedMetric = () => {
    return (
      <ActionableMetricViewV2
        data={{
          title: "outboundARV2.picked",
          message: "Picked",
          value: getRouteCountByStatus(PENDING_STAGE, routeList),
          targetTab: getTargetTabByMetric(PENDING_STAGE),
          uri: getMetricUri(PENDING_STAGE, capability.data),
        }}
      />
    );
  };

  const renderStagedMetric = () => {
    return (
      <StaticMetricView
        data={{
          title: "outboundARV2.staged",
          message: "Staged",
          value: getRouteCountByStatus(PENDING_DEPART, routeList),
        }}
      />
    );
  };

  const renderDepartedMetric = () => {
    return (
      <StaticMetricView
        data={{
          title: "outboundARV2.departed",
          message: "Departed",
          value: getRouteCountByStatus(DEPARTED, routeList),
        }}
      />
    );
  };

  const renderStatusBreakdownView = () => {
    return (
      <Box type="outline" spacingInset={"medium"}>
        <Column spacingInset={"none"}>
          {/* Title */}
          <Text type="h200">
            <FormattedMessage
              id="outboundARV2.statusBreakdown"
              defaultMessage="Status breakdown"
            />
          </Text>
          {/* Metrics */}
          <Row width="100%" spacing={"large"}>
            {renderAtRiskMetric()}
            {renderToBeCutMetric()}
            {renderNotAssignedMetric()}
            {renderInProgressMetric()}
            {renderPickedMetric()}
            {renderStagedMetric()}
            {renderDepartedMetric()}
          </Row>
        </Column>
      </Box>
    );
  };

  return (
    <Column spacingInset="medium medium none large" spacing="small">
      <RefreshTimer
        deps={[viewModel.lastUpdated]}
        lastUpdated={viewModel.lastUpdated}
      />
      <Row width="100%" alignmentVertical="stretch" spacing="medium">
        {renderTotalsView()}
        {renderStatusBreakdownView()}
      </Row>
    </Column>
  );
};

export default injectIntl(OutboundOverviewARV2View);



// WEBPACK FOOTER //
// ./src/components/outboundARv2/OutboundOverviewARV2View.js